import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import Layout from "../../../components/layout/Layout";
import "../../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../../assets/InnerCSS/css/styles.css";
import "../../../assets/InnerCSS/css/custom.css";
import AdminPostRequirementComponent from "../../../components/admin/company/admin-post-job/AdminPostRequirementComponent";
import IdNameModel from "../../../models/common/IdNameModel";
import masterDataService from "../../../services/master-data-service";
import toasterUtils from "../../../utils/toaster-utils";
import modalUtils from "../../../utils/modal-utils";
import { RoleEnum } from "../../../models/enums/RoleEnum";
import adminCompanyService from "../../../services/admin/admin-company-service";
import CompanyConfigurationModel from "../../../models/company/CompanyConfigurationModel";
import { useHistory } from "react-router";
import { ScreenEnum } from "../../../models/enums/StatusEnum";

var companyConfigurationDefault: CompanyConfigurationModel = {
    companyId: "",
    countryId: 1
};

const AdminPostRequirement = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [companyList, setCompaniesList] = useState<IdNameModel[]>([]);
    const [refreshCompany, setRefreshCompany] = useState<number>(2);
    const [companyConfiguration, setCompanyConfiguration] = useState<CompanyConfigurationModel>(companyConfigurationDefault);
    const [jobTypes, setJobTypes] = useState<IdNameModel[]>([]);
    const [assessmentTypes, setAssessmentTypes] = useState<IdNameModel[]>([]);    
    const [primarySkills, setPrimarySkills] = useState<IdNameModel[]>([]);
    const [experiences, setExperiences] = useState<IdNameModel[]>([]);
    const [cities, setCities] = useState<IdNameModel[]>([]);
    const [designations, setDesignations] = useState<IdNameModel[]>([]);
    const [salaries, setSalaries] = useState<IdNameModel[]>([]);
    const [escalationStatusList, setEscalationStatusList] = useState<IdNameModel[]>([]);
    const [refreshEscalationStatus, setRefreshEscalationStatus] = useState<number>(2);

    useEffect(() => {
        fillCompanies();
        fillJobTypes();
        fillAssessmentTypes();
        fillPrimarySkills();
        fillExperiences();
        fillSalaries();
        fillCities();
        getEscalationStatusList();
        //getCompanyConfiguration();
    }, []);

    const fillCompanies = () => {
        setRefreshCompany(2);
        if (loggedInUser && parseInt(loggedInUser.roleId) === parseInt(RoleEnum.Administrator.toString())) {
            modalUtils.showLoader();
            masterDataService.loadCompanies().then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setCompaniesList(res.items);
                setRefreshCompany(refreshCompany * 5);
            }).catch((error) => {
                setRefreshCompany(refreshCompany * 5);
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        } else {
            modalUtils.showLoader();
            adminCompanyService.getCompaniesForIAIRecruiter(loggedInUser ? loggedInUser.profileId : "").then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setCompaniesList(res.items);
                setRefreshCompany(refreshCompany * 5);
            }).catch((error) => {
                setRefreshCompany(refreshCompany * 5);
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const fillJobTypes = () => {
        masterDataService.loadJobTypes().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setJobTypes(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillAssessmentTypes = () => {
        masterDataService.loadInterviewTypes().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setAssessmentTypes(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };    

    const fillPrimarySkills = () => {
        masterDataService.loadPrimarySkills().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setPrimarySkills(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillExperiences = () => {
        masterDataService.loadExperiences().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setExperiences(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillCities = () => {
        masterDataService.loadAllCities().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCities(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillSalaries = () => {
        masterDataService.loadSalaries().then((res) => {
            setSalaries(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getEscalationStatusList = () => {
        masterDataService.loadStatusByScreen(ScreenEnum.EscalationsStatus).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setEscalationStatusList(res.items);
            setRefreshEscalationStatus(refreshEscalationStatus * 5);
        }).catch((error) => {
            setRefreshEscalationStatus(refreshEscalationStatus * 5);
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Post Job
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Post Job </h4>
            </div>
            {refreshCompany > 2 && jobTypes.length > 0 && assessmentTypes.length > 0 && 
                primarySkills.length > 0 && experiences.length > 0
                && cities.length > 0 //&& designations.length > 0
                && salaries.length > 0 &&
                <AdminPostRequirementComponent companiesList={companyList}
                    companyConfiguration={companyConfiguration}
                    jobTypes={jobTypes}
                    assessmentTypes={assessmentTypes}
                    primarySkills={primarySkills}
                    experiences={experiences}
                    cities={cities}
                    designations={designations}
                    salaries={salaries}
                    escalationStatusList={escalationStatusList} />
            }
        </Layout>
    );
};
export default AdminPostRequirement;